/**
 * Created by yilmaz on 17.06.24.
 * Project: alea-carehome-web
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { BedSoreSelectionItem } from '../BedsoreSelection.tsx';

export type TooltipProps = {
  content: string;
  direction: 'left' | 'right';
  verticalDistance: number;
  boundaryDistance: number;
  placementDistance: number;
  id: string;
  selection?: BedSoreSelectionItem;
  modalVisible?: boolean;
};

const Tooltip: React.FC<TooltipProps> = ({
  content,
  direction,
  verticalDistance,
  boundaryDistance,
  placementDistance,
  selection,
  modalVisible = false,
}) => {
  const selectionClass = selection ? `has-${selection.risk}` : '';
  // translation hook
  const { t } = useTranslation();
  return (
    <>
      <div
        className={`tooltip ${selectionClass} ${direction}`}
        style={{
          top: verticalDistance - 22,
          transform:
            direction === 'left'
              ? `translateX(-${placementDistance}px)`
              : `translateX(${placementDistance}px)`,
          width: `${boundaryDistance + placementDistance}px`,
        }}
      >
        <div
          className="tooltip-line"
          style={{
            left: 0,
            bottom: 0,
            width: `${boundaryDistance + placementDistance}px`,
          }}
        ></div>
        <div className="tooltip-content">{t(content)}</div>
        {!modalVisible && selection && (
          <div className={`tooltip-note tooltip-note-${direction}`}>
            {selection.note}
          </div>
        )}
      </div>
    </>
  );
};

export default Tooltip;
